import { Component, computed, inject, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { GuidelineService } from 'shared/domain';
import { LabelDirective, LanguagePickerComponent } from 'shared/ui-common';
import { NamePipe, UtcToLocalPipe } from 'shared/util-common';

import { AllComponentTypes, CodingValue } from '@treetop/shared/model';

import { CodingSystemsSelectorComponent } from './coding-systems-selector/coding-systems-selector.component';
import { DividerComponent } from '../../../../../../../shared/ui-common/src/lib/components/divider/divider.component';

@Component({
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslocoModule,
    MatTabsModule,
    LanguagePickerComponent,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatInputModule,
    UtcToLocalPipe,
    NamePipe,
    LabelDirective,
    CodingSystemsSelectorComponent,
    DividerComponent,
  ],
  selector: 'guideline-sidebar-header',
  templateUrl: './sidebar-header.component.html',
  styleUrls: ['./sidebar-header.component.scss'],
})
export class SidebarHeaderComponent {
  private router = inject(Router);
  private guidelineService = inject(GuidelineService);

  protected vm = computed(() => {
    const guidelineData = this.guidelineService.guidelineData();

    return {
      providerOrganisation: guidelineData.providerOrganisation,
      version: guidelineData.version,
      reviewer: guidelineData.approvedBy,
      publisher: guidelineData.publisher,
      publishedAt: guidelineData.publishedAt,
      approvedAt: guidelineData.approvedAt,
      code: guidelineData.code,
      languageCode: guidelineData.languageCode,
      codings: guidelineData.codings,
    };
  });

  protected isEditPage = signal(this.router.url.includes('template/edit') || this.router.url.includes('guideline/edit'));
  protected searchResults = signal<AllComponentTypes[]>([]);

  protected handleCodingsChanged(codings: CodingValue[]) {
    this.guidelineService.updateGuidelineHeader({ codings });
  }

  protected handleLanguageChanged(languageCode: string) {
    this.guidelineService.updateGuidelineHeader({ languageCode });
  }
}
